// 服務英文名稱（software_services.name）→ chip 配色對照表
//
// 對照來源：應用目錄（CATALOG）每個服務卡片的 iconBg / iconFg 配對。
//           chip 直接沿用同一組色票，讓列表 chip 與應用目錄的服務色一致。
// 使用時機：所有顯示「服務名稱」的 chip 一律走 getServiceColor 取色，
//           不要再用 software_service id 寫死顏色（舊做法只有 id 2 藍 / id 7 橘 /
//           id 8 黑，其餘全部同一個 primary，服務一多就分不出來）。
//
// key 與 [SERVICE_NAME_MAP] 完全相同（都是後端英文 name），兩張表要一起維護：
// 新增服務時同時補名稱與配色，缺配色只會退到 NEUTRAL，不會壞畫面。
//
// 備註：
// - START-ONE 與平台層產品（Content Gallery Platform 等）不在應用目錄裡，
//   沒有對應色票 → 用 NEUTRAL 中性灰。這是刻意決定，不是漏補。
// - bg 為淺底、fg 為同色系深字，成對使用；不要單獨換其中一個。
const NEUTRAL = { bg: "#E9EAEC", fg: "#1F2937" };

export const SERVICE_COLOR_MAP = {
  // 核心服務
  "AI Analysis": { bg: "#E9DBFF", fg: "#7544CD" },
  "File Center": { bg: "#DDF5FD", fg: "#0067B5" },
  "Keystone Core": { bg: "#E1E8FD", fg: "#005BD2" },
  "Document Management": { bg: "#FDF0D1", fg: "#B4790A" },
  "Strategy Mindmap": { bg: "#E7FAD8", fg: "#3F8A1C" },
  // TODO(設計確認)：應用目錄沒有「代理人」這張卡，色票是先挑一個未被佔用的青色頂著。
  // DB 目前 status=0 未啟用，畫面上還看不到；上線前請換成設計給的正式色。
  Agent: { bg: "#D9F2F7", fg: "#0E7490" },
  // 企業限定服務
  "Org Chart": { bg: "#FDF0D2", fg: "#C97D0B" },
  Blueprint: { bg: "#EFE9FD", fg: "#6B46C1" },
  "eip Management": { bg: "#D5FAEF", fg: "#0E9F6E" },
  "Keystone Core Performance": { bg: "#F3EDE8", fg: "#8B5E34" },
  "Permission Management": { bg: "#F7E8FF", fg: "#8632B6" },
  "Data Center": { bg: "#FAE7ED", fg: "#C2255C" },
  "Automation Task": { bg: "#DEE7FF", fg: "#4F46E5" },
  // 簽核管理的另一個後端別名，與 eip Management 同色
  "Approval Management": { bg: "#D5FAEF", fg: "#0E9F6E" },
};

// 傳入英文服務名稱，回傳 { bg, fg }；查無對照時回傳中性灰（含空值防呆）
export const getServiceColor = (name) =>
  (name == null ? null : SERVICE_COLOR_MAP[name]) ?? NEUTRAL;
